import mutations from './referral.mutations'
import actions from './referral.actions'
import getters from './referral.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
